import { getLoginHostUrl } from "@/lib/marketing/login-host";
import { BrandMark } from "@/components/marketing/site/marketing-shell-brand-mark";
import { FooterColumn } from "@/components/marketing/site/marketing-shell-footer-column";

export function MarketingFooter() {
  const year = new Date().getFullYear();
  return (
    /* Positioned, so it paints over the home page's fixed sky. */
    <footer className="relative z-10 bg-background font-ui">
      <div className="mx-auto max-w-6xl px-4 py-14">
        {/* The columns' headings sit under this one, whatever level the page above ended on. */}
        <h2 className="sr-only">Site links</h2>
        <div className="grid gap-10 md:grid-cols-[1.4fr_1fr_1fr_1fr]">
          <div className="space-y-4">
            <BrandMark testId="link-home-footer" />
            <p className="max-w-xs text-sm text-muted-foreground">
              PEOPLE AI Workforce (PPL AI) is the AI workforce for senior living: AI employees that
              run a community's administrative company on one system of record.
            </p>
            <p className="max-w-xs text-xs text-muted-foreground">
              HIPAA compliant, Role-based access, Per-organization data isolation, Hourly encrypted
              off-site backups, ESIGN/UETA-aligned e-signing
            </p>
          </div>
          <FooterColumn
            title="Product"
            links={[
              { label: "AI Workforce", href: "/workforce" },
              { label: "Operating System", href: "/operating-system" },
              { label: "Solutions", href: "/solutions" },
              { label: "Pricing", href: "/pricing" },
              { label: "Security", href: "/security" },
            ]}
          />
          <FooterColumn
            title="Company"
            links={[
              { label: "Case Studies", href: "/case-studies" },
              { label: "About", href: "/about" },
              { label: "Contact us", href: "/contact" },
              { label: "Privacy", href: "/legal/privacy" },
              { label: "Sign in", href: getLoginHostUrl(), external: true },
            ]}
          />
          <FooterColumn
            title="Get started"
            links={[
              { label: "Terms of Service", href: "/terms" },
              { label: "Business Associate Agreement", href: "/baa" },
              { label: "Try the AI employees", href: "/experience" },
              { label: "Book a demo", href: "/demo" },
              { label: "Request information", href: "/inquire" },
              { label: "Compare plans", href: "/pricing" },
              { label: "Talk to us", href: "/contact" },
            ]}
          />
        </div>
        <p className="mt-14 text-sm text-muted-foreground" data-testid="text-copyright">
          © {year} PEOPLE AI Workforce. All rights reserved.
        </p>
      </div>
    </footer>
  );
}
